module.exports = __webpack_public_path__ + "media/images/countryrect/bd-6241689a9ed8e9f6f5b9cb52cb7ca83e.svg";